/** @jsxRuntime classic */
/** @jsx jsx */

import { forwardRef, memo, useImperativeHandle, useLayoutEffect, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { displayBlock, pointerEventsNone, positionRelative, userSelectNone } from "../../../styles/general";
import { useColor as colors } from "../../../theme";
const {
  semantic: {
    danger
  }
} = colors;
const Control = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  children,
  className,
  disabled,
  error,
  style,
  ...props
}, reference) => {
  const ref = useRef(null);
  const classes = {
    disabled: 'DGN-UI-Control-disabled',
    error: 'DGN-UI-Control-error'
  };
  useLayoutEffect(() => {
    if (disabled) {
      ref.current.classList.add(classes.disabled);
    }
    if (!disabled && error) {
      ref.current.classList.add(classes.error);
      ref.current.querySelector('div.DGN-UI-InputBase').classList.add('danger');
    }
    return () => {
      if (disabled) {
        ref.current.classList.remove(classes.disabled);
      }
      if (!disabled && error) {
        ref.current.classList.remove(classes.error);
        ref.current.querySelector('div.DGN-UI-InputBase').classList.remove('danger');
      }
    };
  }, [disabled, error]);
  useImperativeHandle(reference, () => {
    const currentRef = ref.current || {};
    const _instance = {}; // methods
    _instance.__proto__ = {}; // hidden methods
    currentRef.instance = _instance;
    return currentRef;
  });
  return jsx("div", {
    ...props,
    className: ['DGN-UI-Control', className].join(' ').trim().replace(/\s+/g, ' '),
    css: controlRootCSS(classes),
    style: style,
    ref: ref
  }, children);
}));
const controlRootCSS = classes => css`
    ${displayBlock}
    ${positionRelative}
    margin-bottom: 20px;
    &.${classes.disabled} {
        ${pointerEventsNone}
        ${userSelectNone}
    }
    &.${classes.error} {
        * :not(label) {
            color: ${danger};
        }
    }
`;
Control.defaultProps = {
  className: '',
  style: {},
  disabled: false,
  error: ''
};
Control.propTypes = {
  /** children of the form control */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
  /** the class for the form control */
  className: PropTypes.string,
  /** prevent all event if true, hide all icon */
  disabled: PropTypes.bool,
  /** error for input */
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** style of the component */
  style: PropTypes.object
};
export default Control;